import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import logo from "assets/img/logo.png";
import {
  reskillingService,
  ReskillingInforme,
} from "services/reskillingService";

/**
 * Informe que se comparte con la persona evaluada.
 *
 * Se accede solo con el token de compartir, que el profesional genera desde el
 * panel y puede revocar. El informe se muestra embebido desde Reskilling: el
 * link y el encabezado son de Neurografy, el contenido lo renderiza el
 * proveedor.
 */
export default function InformePublico() {
  const { token } = useParams<{ token: string }>();
  const [informe, setInforme] = useState<ReskillingInforme | null>(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) return;

    let cancelado = false;

    reskillingService
      .obtenerInformePublico(token)
      .then((data) => {
        if (!cancelado) setInforme(data);
      })
      .catch(() => {
        if (!cancelado) {
          setError(
            "Este informe no está disponible. Es posible que el link haya sido dado de baja."
          );
        }
      })
      .finally(() => {
        if (!cancelado) setCargando(false);
      });

    return () => {
      cancelado = true;
    };
  }, [token]);

  if (cargando) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-4 border-gray-200 border-t-brand-500"></div>
          <p className="text-gray-600">Cargando tu informe…</p>
        </div>
      </div>
    );
  }

  if (error || !informe?.report_url) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-100 px-4">
        <div className="w-full max-w-md rounded-lg bg-white p-6 text-center shadow-lg">
          <img
            src={logo}
            alt="Neurografy"
            className="mx-auto mb-6 h-16 w-auto"
          />
          <p className="text-sm text-gray-600">
            {error || "Este informe todavía no está disponible."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-gray-100">
      <header className="border-b bg-white px-4 py-3 shadow-sm">
        <div className="mx-auto flex max-w-6xl items-center gap-3">
          <img src={logo} alt="Neurografy" className="h-10 w-auto shrink-0" />
          <div className="min-w-0">
            <h1 className="truncate text-base font-semibold text-gray-800 md:text-lg">
              {informe.persona.nombre
                ? `Informe de ${informe.persona.nombre}`
                : "Tu informe de habilidades"}
            </h1>
            {informe.completada_el && (
              <p className="text-xs text-gray-500">
                Completado el{" "}
                {new Date(informe.completada_el).toLocaleDateString("es-AR")}
              </p>
            )}
          </div>
        </div>
      </header>

      <iframe
        src={informe.report_url}
        title="Informe de habilidades"
        className="w-full flex-1 border-0"
      />
    </div>
  );
}
